type EntityType = {
	x: number;
	y: number;
	z: number;
	width: number;
	height: number;
	depth: number;
};

export function getDimensions(entity: EntityType) {
	return {
		x: entity.x / 1000 + entity.width / 2 / 1000,
		y: entity.y / 1000 + entity.height / 2 / 1000,
		z: entity.z / 1000 + entity.depth / 2 / 1000,
		width: entity.width / 1000,
		height: entity.height / 1000,
		depth: entity.depth / 1000,
	};
}
